module.exports = __webpack_public_path__ + "distribution/img/saveImg.50b522c1.png";